import React from 'react';
import { useNavigate } from 'react-router';
import { Section, Cell } from '@telegram-apps/telegram-ui';
import { Expense, ExpenseCategory } from '../../../types';
import { formatDate } from '../../../utils';

interface TableProps {
  expenses: Expense[];
}

const categoryIcons: Record<ExpenseCategory, string> = {
  food: '🍚',
  transportation: '🚉',
  shopping: '🛍️',
  entertainment: '🎢',
  bills: '🧾',
  other: '💸',
}

export default function Table({ expenses }: TableProps) {
  const navigate = useNavigate();

  const data = React.useMemo(
    () => expenses.sort((a, b) => b.date.getTime() - a.date.getTime()),
    [expenses]
  );

  return (
    <>
      <Section header="概要">
        <Cell
          after={<div>{`総額　¥${expenses.reduce((acc, expense) => acc + expense.amount, 0)}`}</div>}
          subtitle={`${expenses.length} 支出`}
        />
      </Section>
      <Section header="明細">
        {
          data.map((expense, i) => 
            <Cell
              key={i}
              subhead={formatDate(expense.date)}
              description={expense.reportedBy}
              before={categoryIcons[expense.category]}
              after={<div>{`¥${expense.amount.toString()}`}</div>}
              onClick={() => navigate(`/expense/${expense.id}`)}
            >
              
              {expense.description}
            </Cell>
          )
        }
      </Section>
      <div style={{height: 100}} />
    </>
  )
}
